import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Dashboard from 'dashboard/Dashboard';
import ProfileContainer from 'profile/ProfileContainer';
import LicenseContainer from 'licenses/LicenseContainer';
import Licenses from 'licenses';
import CreateOrderForm from 'CreateOrderForm';
import Orders from 'orders';
import OrderContainer from 'orders/OrderContainer';
import LicenseUsers from 'licenseUsers';
import LicenseUserGroups from 'licenseUsers/licenseUserGroups';
import LicenseUserGroupDetails from 'licenseUsers/licenseUserGroups/LicenseUserGroupDetails';
import LicenseUserDetails from 'licenseUsers/LicenseUserDetails';
import Header from 'header';
import {
  getManagerPermissions,
  getManagerCounter,
  getUserCompany,
  getUser,
} from 'redux/user/actions';
import { getCompanyFeatures } from 'redux/companyFeatures/actions';
import { ContentLoader } from 'shared/components';
import CustomerAccount from 'customerAccounts/CustomerAccount';
import CustomerAccountsList from 'customerAccounts/CustomerAccountsList';

const AppContainer = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const userID = get(auth, 'user.profile.platform_user_id');

  const userLoading = useSelector((state) => get(state, 'user.loading'));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userID) {
      return;
    }

    dispatch(getUser(userID));
    dispatch(getUserCompany(userID));
    dispatch(getManagerPermissions(userID));
    dispatch(getManagerCounter(userID));
    dispatch(getCompanyFeatures());
  }, [dispatch, userID]);

  if (userLoading) {
    return <ContentLoader text={t('Getting account details')} />;
  }

  return (
    <>
      <Header />
      <Switch>
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/licenses" component={Licenses} />
        <Route path="/licenses/:licenseId" component={LicenseContainer} />
        <Route exact path="/orders" component={Orders} />
        <Route path="/orders/:orderId" component={OrderContainer} />
        <Route exact path="/license_users" component={LicenseUsers} />
        <Route
          exact
          path="/license_users/user_groups"
          component={LicenseUserGroups}
        />
        <Route
          exact
          path="/license_users/user_groups/:groupId"
          component={LicenseUserGroupDetails}
        />
        <Route
          exact
          path="/license_users/:licenseUserId"
          component={LicenseUserDetails}
        />
        <Route
          path="/create-order/:orderId"
          exact
          component={CreateOrderForm}
        />
        <Route path="/create-order" component={CreateOrderForm} />
        <Route path="/profile" component={ProfileContainer} />
        <Route
          exact
          path="/customer-accounts"
          component={CustomerAccountsList}
        />
        <Route
          path="/customer-accounts/:accountId"
          component={CustomerAccount}
        />
      </Switch>
    </>
  );
};

export default AppContainer;
